import styled from 'styled-components';

// o h2 do preço herda o estilo do card onde o componente é usado
// selo com as mesmas cores do título da categoria (CategoriaProdutos/ContainerTitulo)
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SeloPromocao = styled.strong`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-family: 'PoppinsBold';
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.backgroundCard};
`;
